import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ giftCardReport, endDate, beginDate }) => (

    <div>
        {
            giftCardReport.list.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                giftCardReport.list.length > 0 &&
                //If there's DATA
                <div>

                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">

                        {
                            giftCardReport.list.map((item, index) => {
                                let status = "";
                                let msg = "";
                                let balance = "";
                                let transactionId = "";
                                let type = "";
                                if (item.provider == "Birchmount") {
                                    const operationParsed = JSON.parse(item.operation);
                                    status = operationParsed.response.STATUS;
                                    msg = operationParsed.response.MSG;
                                    balance = operationParsed.response.BALANCE;
                                    transactionId = operationParsed.response.TRANSACTION_ID;
                                } else if (item.provider == "Moneris") {
                                    const operationParsed = item.operation.split(", ")
                                    type = operationParsed[0];
                                    msg = operationParsed[1];
                                    balance = "$" + operationParsed[2].split(": ")[1];
                                    transactionId = operationParsed[3].split(": ")[1];
                                } else if (item.provider == "Generic") {
                                    const operationParsed = item.operation.split("-")
                                    type = operationParsed[0];
                                    msg = operationParsed[1];

                                    const operationParsedColon = item.operation.split(": ")
                                    balance = "$" + operationParsedColon[2]
                                }

                                return (
                                    <div className="row m-0 border_bottom_grey pt-2 pb-2 price_info col-4-padding" key={index}>

                                        <div className="col-lg-12 daily_cash">
                                            <div className="row m-0">
                                                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 m-0 p-0">

                                                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                        <h5>Id</h5>
                                                        <span>{item.id}</span>
                                                    </div>
                                                    <div className="col-lg-5 col-md-5 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                        <h5>Transaction Id</h5>
                                                        <span>{transactionId == "" ? "n/a" : transactionId}</span>
                                                    </div>
                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                        <h5>Date</h5>
                                                        <span>{moment(item.timeStamp).format('MMMM Do, YYYY')}</span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 m-0 p-0">

                                                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                        {item.provider == "Birchmount" ?
                                                            <div>
                                                                <h5>Status</h5>
                                                                <span>{status}</span>
                                                            </div>
                                                            : <div>
                                                                <h5>Type</h5>
                                                                <span>{type}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                        <h5>Balance</h5>
                                                        <span>{balance == null ? "n/a" : balance}</span>
                                                    </div>
                                                    <div className="col-lg-8 col-md-8 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                        <h5>Message</h5>
                                                        <span>{msg}</span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 m-0 p-0">
                                                    <div className="col-lg-12 col-md-12 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        <h5>Employee</h5>
                                                        <span>{item.employeeName}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div>
);

export default Body;


